// src/Pages/Auth/variants/index.js
//
// Which narrative the sign-in page shows, and how to add another.
//
// TO ADD A VARIANT:
//   1. Write the component in this folder. It receives ({ compact, ctx }).
//      `compact` is true on mobile (the top strip) and false on desktop (the
//      left panel). See DefaultNarrative.jsx for the shape.
//   2. Import it below, add it to VARIANTS.
//   3. Add a rule to RULES, ABOVE any rule it should beat.
//
// RULES ARE ORDERED — first match wins. Most specific at the top, catch-all
// last. Every rule gets the whole landing context, so it can test source,
// vertical, utm campaign, affiliate code, or any combination.

import DefaultNarrative from './DefaultNarrative';
import ReviewPreviewNarrative from './ReviewPreviewNarrative';
import IndustryNarrative from './IndustryNarrative';
import { resolveIndustry } from './industries';

export const VARIANTS = {
  default: DefaultNarrative,

  // Step 2:
  reviewPreview: ReviewPreviewNarrative,
  industry: IndustryNarrative,

  // Later, per vertical:
  // salonPreview:      SalonPreviewNarrative,
  // restaurantPreview: RestaurantPreviewNarrative,
};

const RULES = [
  // --- Per-vertical preview variants. Above the generic preview rule.
  // { id: 'salonPreview',
  //   test: (ctx) => ctx.source === 'preview' && ctx.vertical?.startsWith('beauty.') },
  // { id: 'restaurantPreview',
  //   test: (ctx) => ctx.source === 'preview' && ctx.vertical?.startsWith('food.') },

  // --- Any preview visitor without a vertical-specific variant.
  { id: 'reviewPreview', test: (ctx) => ctx.source === 'preview' },

  // --- Ad and social traffic, by campaign.
  { id: 'industry', test: (ctx) => !!resolveIndustry(ctx) },

  // --- Affiliate referrals. No affiliates live yet.
  // { id: 'affiliate', test: (ctx) => ctx.source === 'affiliate' },

  // --- Catch-all. Must stay last.
  { id: 'default', test: () => true },
];

/**
 * Resolve a landing context to a variant id.
 * Falls back to 'default' when a rule names a variant that isn't registered,
 * so a half-finished variant can't blank the sign-in page.
 */
export function resolveVariantId(ctx) {
  for (const rule of RULES) {
    try {
      if (rule.test(ctx)) {
        return VARIANTS[rule.id] ? rule.id : 'default';
      }
    } catch (e) {
      console.warn('variant rule threw, skipping:', rule.id, e);
    }
  }
  return 'default';
}

/** Resolve straight to the component. This is what SignIn calls. */
export function resolveNarrative(ctx) {
  return VARIANTS[resolveVariantId(ctx)] || VARIANTS.default;
}